import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { fetchPurchase } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import {
  getTaxNumFromStr,
  getTaxableFromValue,
  roundOff,
  isValidItem,
  setTaxPaidRate,
  getRowColData,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import TaxMaster from "./TaxMaster";
import ItemMaster from "./ItemMaster";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import SetTaxPaidRate from "./SetTaxPaidRate";
import MoreInfoTextEditor from "./MoreInfoTextEditor";

class PurchaseItemEntry extends Component {
  state = {
    ItemNameList: [],
    PackingList: [],
    TaxNameList: [],
    StoreNameList: [],
    edit_purchasesrno: "",
    DefaultStoreName: "",
    formData: {
      cmbStoreName: "",
      txtSrNo: "",
      cmbItemName: "",
      cmbPacking: "",
      txtStock: "",
      txtPurRate: "",
      txtHSN: "",
      txtRate: "",
      txtQty: "",
      txtBasicAmt: "",
      txtDis: "",
      txtDisAmt: "",
      txtTaxable: "",
      cmbTaxName: "",
      txtCGST: "",
      txtSGST: "",
      txtIGST: "",
      txtTotalAmt: "",
      txtRemark: "",
    },
    dataLoadStatus: true,
    ARD: null,
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    // document.title = "RiTe Account : Purchase Item Entry";
    this.props.setActiveMenu("PurchaseItemEntry");
    this.ShortCut();
    this.onFormLoad();
  }
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name == "cmbItemName" || e.target.name == "cmbPacking") {
          if (e.target.name == "cmbItemName") {
            this.setItemDetail();
            // this.getRate()//Load HSN, Packing, Tax Name
          }
        } else if (e.target.name == "txtRate" || e.target.name == "txtQty") {
          this.calBasicAmount();
        } else if (e.target.name == "txtDis") {
          this.calDisAmount();
        } else if (e.target.name == "txtDisAmt") {
          this.getTaxableBasedOnDisAmt();
        } else if (e.target.name == "cmbTaxName") {
          this.calTax_CSGT_SGST_IGST();
        } else if (e.target.name == "txtTotalAmt") {
          this.calcAmtBasedOnTotalAmountInReverse();
        }
      }
    );
  };
  //#endregion handle

  //#region function
  calcAmtBasedOnTotalAmountInReverse = () => {
    let txtTotalAmt = Number(this.state.formData.txtTotalAmt),
      cmbTaxName = this.state.formData.cmbTaxName,
      numTax = getTaxNumFromStr(cmbTaxName),
      txtTaxable = getTaxableFromValue(numTax, txtTotalAmt),
      txtBasicAmt =
        Number(this.state.formData.txtDisAmt) > 0
          ? txtTaxable - Number(this.state.formData.txtDisAmt)
          : txtTaxable,
      txtRate =
        Number(this.state.formData.txtQty) > 0
          ? roundOff(txtBasicAmt / Number(this.state.formData.txtQty), 2)
          : "";

    this.setState({
      formData: {
        ...this.state.formData,
        txtTaxable,
        txtBasicAmt,
        txtRate,
      },
    });
  };

  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickSave: this.savePurchaseItem,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: this.onDeleteBtnClick,
        handleOnclickPluse: this.onAddClickItem,
      }),
    });
  };
  validatePurchaseItem = () => {
    let result = false;
    if (
      !isValidItem(
        this.state.StoreNameList,
        "vac_storename",
        this.state.formData.cmbStoreName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Store Name", "cmbStoreName");
    } else if (this.state.formData.cmbItemName.length <= 0) {
      this.props.toastErrorMsg("Select Item Name", "cmbItemName");
    } else if (
      isValidItem(
        this.state.ItemNameList,
        "vac_itemname",
        this.state.formData.cmbItemName
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Item Name", "cmbItemName");
    } else if (this.state.formData.cmbPacking.length <= 0) {
      this.props.toastErrorMsg("Select Packing Name", "cmbPacking");
    } else if (
      !isValidItem(
        this.state.ItemNameList,
        "vac_unit",
        this.state.formData.cmbPacking
      )
    ) {
      this.props.toastErrorMsg("Select Valid Packing Name", "cmbPacking");
    } else if (this.state.formData.txtQty <= 0) {
      this.props.toastErrorMsg("Enter Quantity", "txtQty");
    } else if (this.state.formData.txtRate <= 0) {
      this.props.toastErrorMsg("Enter Rate", "txtRate");
    } /* else if (this.state.formData.txtDis < 0) {
      this.props.toastErrorMsg("Enter Discount (%)", "txtDis");
    } else if (this.state.formData.txtDisAmt < 0) {
      this.props.toastErrorMsg("Enter Discount Amount", "txtDisAmt");
    } */ else if (this.state.formData.cmbTaxName.length <= 0) {
      this.props.toastErrorMsg("Select Tax Name", "cmbTaxName");
    } else if (
      !isValidItem(
        this.state.TaxNameList,
        "vac_taxname",
        this.state.formData.cmbTaxName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Tax Name", "cmbTaxName");
    } else {
      result = true;
    }
    return result;
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      let ItemNameList = [],
        PackingList = [],
        TaxNameList = [],
        StoreNameList = [],
        edit_purchasesrno = 0;
      if (
        this.props.ItemNameList &&
        this.props.TaxNameList &&
        this.props.StoreList
      ) {
        // console.log("call");
        ItemNameList = this.props.ItemNameList;
        PackingList = this.props.PackingList;
        TaxNameList = this.props.TaxNameList;
        StoreNameList = this.props.StoreList;
        edit_purchasesrno = this.props.edit_purchasesrno;
        this.setState(
          {
            ItemNameList,
            PackingList,
            TaxNameList,
            edit_purchasesrno,
            dataLoadStatus: true,
            StoreNameList,
          },
          () => {
            this.getDefaultStoreName();
          }
        );
      }
      if (this.props.bint_itemsrno && Number(this.props.bint_itemsrno) > 0) {
        if (
          this.props.EditPurchaseItemData &&
          this.props.EditPurchaseItemData.length > 0
        ) {
          let EditPurchaseItemData = this.props.EditPurchaseItemData;
          this.setState({
            formData: {
              ...this.state.formData,
              txtSrNo: EditPurchaseItemData[0].bint_itemsrno,
              cmbItemName: EditPurchaseItemData[0].vac_itemname,
              cmbStoreName: EditPurchaseItemData[0].vac_storename,
              cmbPacking: EditPurchaseItemData[0].vac_unit,
              txtHSN: EditPurchaseItemData[0].vac_hsncode,
              txtRate: EditPurchaseItemData[0].dec_rate,
              txtQty: EditPurchaseItemData[0].dec_qty,
              txtBasicAmt: EditPurchaseItemData[0].dec_basicamt,
              txtDis: EditPurchaseItemData[0].dec_disper,
              txtDisAmt: EditPurchaseItemData[0].dec_disamt,
              txtTaxable: EditPurchaseItemData[0].dec_taxable,
              cmbTaxName: EditPurchaseItemData[0].vac_taxname,
              txtCGST: EditPurchaseItemData[0].dec_cgstamt,
              txtSGST: EditPurchaseItemData[0].dec_sgstamt,
              txtIGST: EditPurchaseItemData[0].dec_igstamt,
              txtTotalAmt: EditPurchaseItemData[0].dec_totalamt,
              txtRemark: EditPurchaseItemData[0].vac_remark,
            },
          });
        }
      }
    });
    document.getElementById("cmbItemName").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtSrNo: "",
          cmbItemName: "",
          cmbPacking: "",
          txtStock: "",
          txtPurRate: "",
          txtHSN: "",
          txtRate: "",
          txtQty: "",
          txtBasicAmt: "",
          txtDis: "",
          txtDisAmt: "",
          txtTaxable: "",
          cmbTaxName: "",
          txtCGST: "",
          txtSGST: "",
          txtIGST: "",
          txtTotalAmt: "",
          txtRemark: "",
        },
      },
      () => {
        document.getElementById("cmbItemName").focus();
      }
    );
  };

  savePurchaseItem = () => {
    if (this.validatePurchaseItem()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SavePurchase_Item",
          bint_acyear: this.props.bint_acyear,
          bint_acid: this.props.bint_acid,
          vac_company: this.props.cmbCompany,
          bint_purchaseno: this.state.edit_purchasesrno,
          dat_purchasedate: this.props.dtpDate,
          vac_billno: this.props.txtBillNo,
          vac_supplier: this.props.cmbSupplier,
          dec_discamt: this.props.txtDiscount,
          dec_taxableamount: this.props.txtTaxable,
          dec_cgst: this.props.txtCGST,
          dec_sgst: this.props.txtSGST,
          dec_igst: this.props.txtIGST,
          dec_grandtotal: this.props.txtGrandTotal,
          dec_advpay: this.props.txtAdvPayment,
          dec_roundoff: this.props.txtRoundOff,
          dec_netpay: this.props.txtNetPayment,
          vac_transactiontype: this.props.cmbTransactionType,
          bint_vouno: 0,
          vac_remark: this.props.txtRemark,
          dec_beforetaxamt: this.props.totalBeforeTaxAmt,
          dec_aftertaxamt: this.props.totalAfterTaxAmt,
          dec_basicamt: this.props.txtbasicamt,
          totalafterDeductionTaxamt: this.props.totalafterDeductionTaxamt,
          totalAfteraddTaxamt: this.props.totalAfteraddTaxamt,
          totalBeforeaddTaxamt: this.props.totalBeforeaddTaxamt,
          totalBeforeDeductionTaxamt: this.props.totalBeforeDeductionTaxamt,
          bint_ci: localStorage.getItem("CI"),
          PurchaseItemData: [
            {
              bint_acid: this.props.bint_acid,
              vac_company: this.state.formData.cmbCompany,
              vac_storename: this.state.formData.cmbStoreName,
              bint_itemsrno: this.state.formData.txtSrNo,
              bint_purchaseno: this.state.formData.edit_purchasesrno,
              vac_itemname: this.state.formData.cmbItemName,
              vac_hsncode: this.state.formData.txtHSN,
              vac_unit: this.state.formData.cmbPacking,
              dec_qty: this.state.formData.txtQty,
              dec_rate: this.state.formData.txtRate,
              dec_basicamt: this.state.formData.txtBasicAmt,
              dec_cashdisper: this.state.formData.txtDis,
              dec_cashdisamt: this.state.formData.txtDisAmt,
              dec_taxableamount: this.state.formData.txtTaxable,
              vac_taxname: this.state.formData.cmbTaxName,
              dec_cgstamt: this.state.formData.txtCGST,
              dec_sgstamt: this.state.formData.txtSGST,
              dec_igstamt: this.state.formData.txtIGST,
              dec_totalamount: this.state.formData.txtTotalAmt,
              vac_remark: this.state.formData.txtRemark,
            },
          ],
          PaymentData:
            this.props.cmbTransactionType == "Paid"
              ? this.props.rowsPaymentMode
              : [],
          OtherDetailData: this.props.rowsOtherDetail,
        };
        fetchPurchase(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let dec_basicamt = 0,
                dec_disamt = 0,
                dec_taxable = 0,
                dec_cgstamt = 0,
                dec_sgstamt = 0,
                dec_igstamt = 0,
                dec_totalamt = 0,
                PurchaseItemData = [],
                edit_purchasesrno = 0;
              if (res.data.PurchaseItemData) {
                PurchaseItemData = res.data.PurchaseItemData;
              }
              if (res.data.PurchaseList) {
                edit_purchasesrno = res.data.PurchaseList[0].bint_purchaseno;
              }
              if (res.data.TotalItemAmountData) {
                dec_basicamt = Number(
                  res.data.TotalItemAmountData[0].dec_basicamt
                );
                dec_disamt = Number(
                  res.data.TotalItemAmountData[0].dec_cashdisamt
                );
                dec_taxable = Number(
                  res.data.TotalItemAmountData[0].dec_taxableamount
                );
                dec_cgstamt = Number(
                  res.data.TotalItemAmountData[0].dec_cgstamt
                );
                dec_sgstamt = Number(
                  res.data.TotalItemAmountData[0].dec_sgstamt
                );
                dec_igstamt = Number(
                  res.data.TotalItemAmountData[0].dec_igstamt
                );
                dec_totalamt = Number(
                  res.data.TotalItemAmountData[0].dec_totalamount
                );
              }
              this.setState(
                {
                  edit_purchasesrno,
                },
                () => {
                  this.props.resetAmount(
                    dec_basicamt,
                    dec_taxable,
                    dec_cgstamt,
                    dec_sgstamt,
                    dec_igstamt,
                    dec_totalamt,
                    dec_disamt,
                    edit_purchasesrno
                  );
                  this.props.refreshPurchaseItemList(
                    PurchaseItemData,
                    PurchaseItemData.length
                  );
                  this.clearInfo();
                }
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in savePurchaseItem.", error);
          });
      });
    }
  };

  onDeleteBtnClick = () => {
    if (Number(this.state.formData.txtSrNo) > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Item : " +
              this.state.formData.cmbItemName +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deletePurchaseItem(
                this.props.bint_acyear,
                this.props.bint_acid,
                this.state.edit_purchasesrno,
                this.state.formData.txtSrNo
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("There are no item to delete", "cmbItemName");
    }
  };

  deletePurchaseItem = (
    bint_acyear,
    bint_acid,
    edit_purchasesrno,
    bint_itemsrno
  ) => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeletePurchaseItem",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_purchaseno: edit_purchasesrno,
        edit_itemsrno: bint_itemsrno,
        dec_advpay: this.props.txtAdvPayment,
        dec_roundoff: this.props.txtRoundOff,
        vac_supplier: this.props.cmbSupplier,
        bint_ci: localStorage.getItem("CI"),
        dat_purchasedate: this.props.dtpDate,
        vac_remark: this.props.txtRemark,
        vac_transactiontype: this.props.cmbTransactionType,
        PaymentData: this.props.rowsPaymentMode,
        vac_billno: this.props.txtBillNo,
      };
      fetchPurchase(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          let dec_basicamt = 0,
            dec_disamt = 0,
            dec_taxable = 0,
            dec_cgstamt = 0,
            dec_sgstamt = 0,
            dec_igstamt = 0,
            dec_totalamt = 0,
            PurchaseItemData = [];
          if (
            res.data.PurchaseItemData &&
            res.data.PurchaseItemData.length > 0
          ) {
            rows = res.data.PurchaseItemData;
            rowsCount = rows.length;
          }
          if (res.data.TotalItemAmountData) {
            dec_basicamt = Number(res.data.TotalItemAmountData[0].dec_basicamt);
            dec_disamt = Number(res.data.TotalItemAmountData[0].dec_disamt);
            dec_taxable = Number(
              res.data.TotalItemAmountData[0].dec_taxableamount
            );
            dec_cgstamt = Number(res.data.TotalItemAmountData[0].dec_cgstamt);
            dec_sgstamt = Number(res.data.TotalItemAmountData[0].dec_sgstamt);
            dec_igstamt = Number(res.data.TotalItemAmountData[0].dec_igstamt);
            dec_totalamt = Number(
              res.data.TotalItemAmountData[0].dec_totalamount
            );
          }
          this.setState(
            {
              ARD: null,
              dataLoadStatus,
            },
            () => {
              this.props.resetAmount(
                dec_basicamt,
                dec_taxable,
                dec_cgstamt,
                dec_sgstamt,
                dec_igstamt,
                dec_totalamt,
                dec_disamt,
                edit_purchasesrno
              );
              this.props.refreshPurchaseItemList(rows, rowsCount);
              this.clearInfo();
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in deletePurchaseItem.", error);
        });
    });
  };

  getSalesRate = () => {
    let dataLoadStatus = false,
      txtRate = 0;
    if (
      this.state.formData.cmbItemName != "" &&
      this.state.formData.cmbItemName.length > 0
    ) {
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "GetSalesRate",
          bint_acyear: this.props.bint_acyear,
          bint_acid: this.props.bint_acid,
          vac_itemname: this.state.formData.cmbItemName,
          vac_supplier: this.props.cmbSupplier,
          vac_unit: this.state.formData.cmbPacking,
        };
        fetchPurchase(reqData)
          .then((res) => {
            txtRate = Number(res.data.dec_rate);
            dataLoadStatus = true;
            this.setState({
              dataLoadStatus,
              formData: {
                ...this.state.formData,
                txtRate,
              },
            });
          })
          .catch((error) => {
            console.log("Unknown error occurred in getPurchaseRate.", error);
          });
      });
    } else {
      this.setState({
        dataLoadStatus,
        formData: {
          ...this.state.formData,
          txtRate,
        },
      });
    }
  };

  getPurchaseRate = () => {
    let dataLoadStatus = false,
      txtPurRate = 0;
    if (
      this.state.formData.cmbPacking.length > 0 &&
      this.state.formData.cmbItemName.length > 0
    ) {
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "GetPurchaseRate",
          bint_acyear: this.props.bint_acyear,
          bint_acid: this.props.bint_acid,
          vac_itemname: this.state.formData.cmbItemName,
          vac_unit: this.state.formData.cmbPacking,
        };
        fetchPurchase(reqData)
          .then((res) => {
            txtPurRate = Number(res.data.dec_purrate);
            // txtPurRate = roundOff(Number(res.data.dec_purrate), 2);
            dataLoadStatus = true;
            this.setState({
              dataLoadStatus,
              formData: {
                ...this.state.formData,
                txtPurRate,
              },
            });
          })
          .catch((error) => {
            console.log("Unknown error occurred in getPurchaseRate.", error);
          });
      });
    }
  };

  calBasicAmount = () => {
    let txtBasicAmt = 0;
    if (
      Number(this.state.formData.txtRate) > 0 &&
      Number(this.state.formData.txtQty) > 0
    ) {
      txtBasicAmt =
        Number(this.state.formData.txtRate) *
        Number(this.state.formData.txtQty);
    }
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtBasicAmt,
          txtTaxable: txtBasicAmt,
        },
      },
      () => {
        this.calDisAmount();
      }
    );
  };

  getTaxableBasedOnDisAmt = () => {
    let txtTaxable =
      Number(this.state.formData.txtBasicAmt) -
      Number(this.state.formData.txtDisAmt);
    this.setState(
      {
        formData: {
          ...this.state.formData,
          // txtDis: "",
          txtTaxable,
        },
      },
      () => {
        this.calTax_CSGT_SGST_IGST();
      }
    );
  };

  calDisAmount = () => {
    let txtDisAmt = 0,
      txtTaxable = 0;
    if (Number(this.state.formData.txtDis) > 0) {
      txtDisAmt =
        (Number(this.state.formData.txtBasicAmt) *
          Number(this.state.formData.txtDis)) /
        100;
      txtTaxable = Number(this.state.formData.txtBasicAmt) - txtDisAmt;
      // console.log('txtTaxable from If', txtTaxable)
    } else if (Number(this.state.formData.txtDisAmt) > 0) {
      txtTaxable =
        Number(this.state.formData.txtBasicAmt) -
        Number(this.state.formData.txtDisAmt);
      // console.log('txtTaxable from Else if, txtBasicAmt, txtDisAmt', txtTaxable, this.state.formData.txtBasicAmt, this.state.formData.txtDisAmt)
    } else {
      txtTaxable = Number(this.state.formData.txtBasicAmt);
    }
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtDisAmt,
          txtTaxable,
        },
      },
      () => {
        this.calTax_CSGT_SGST_IGST();
        this.getTaxableBasedOnDisAmt();
      }
    );
  };

  calTax_CSGT_SGST_IGST = () => {
    let txtIGST = 0,
      txtSGST = 0,
      txtCGST = 0;
    if (this.state.formData.cmbTaxName.length > 0) {
      const txtTaxable = Number(this.state.formData.txtTaxable),
        cmbTaxName = getTaxNumFromStr(this.state.formData.cmbTaxName);
      //Number(this.state.formData.cmbTaxName.substring(0, this.state.formData.cmbTaxName.length - 1))
      let txtCGST = 0,
        txtSGST = 0,
        txtIGST = 0;
      console.log("this.props.SupplierStateCode", this.props.SupplierStateCode);
      if (Number(txtTaxable) >= 0 && Number(cmbTaxName) >= 0) {
        txtCGST = (txtTaxable * (cmbTaxName / 2)) / 100;
        txtCGST = txtCGST.toFixed(2);
        txtSGST = txtCGST;
        if (
          this.props.SupplierStateCode != localStorage.getItem("CompStateCode")
        ) {
          txtIGST = Number(txtCGST) + Number(txtSGST);
          txtCGST = 0;
          txtSGST = 0;
        }
      }
      this.setState(
        {
          formData: {
            ...this.state.formData,
            txtCGST: Number(txtCGST),
            txtSGST: Number(txtSGST),
            txtIGST: Number(txtIGST),
          },
        },
        () => {
          // console.log("txtCGST", txtCGST);
          // console.log("txtSGST", txtSGST);
          // console.log("txtIGST", txtIGST);
          // console.log("this.state.formData.txtCGST", this.state.formData.txtCGST);
          // console.log("this.state.formData.txtSGST", this.state.formData.txtSGST);
          // console.log("this.state.formData.txtIGST", this.state.formData.txtIGST);
          this.calTotalAmount();
        }
      );
    }
  };

  calTotalAmount = () => {
    let txtTotalAmt = 0;
    if (Number(this.state.formData.txtTaxable) > 0) {
      txtTotalAmt =
        Number(this.state.formData.txtTaxable) +
        Number(this.state.formData.txtSGST) +
        Number(this.state.formData.txtCGST) +
        Number(this.state.formData.txtIGST);
      txtTotalAmt = txtTotalAmt.toFixed(2);
    }
    this.setState({
      formData: {
        ...this.state.formData,
        txtTotalAmt,
      },
    });
  };

  getDefaultStoreName = () => {
    if (this.state.StoreNameList.length > 0) {
      this.state.StoreNameList.map((row) => {
        if (row.int_default == 1 || row.int_default == "1") {
          this.setState({
            DefaultStoreName: row.vac_storename,
            formData: {
              ...this.state.formData,
              cmbStoreName: row.vac_storename,
            },
          });
        }
      });
    }
  };

  setItemDetail = () => {
    if (
      this.state.ItemNameList.length > 0 &&
      this.state.formData.cmbItemName.length > 0
    ) {
      this.state.ItemNameList.map((row) => {
        if (row.vac_itemname == this.state.formData.cmbItemName) {
          this.setState(
            {
              formData: {
                ...this.state.formData,
                cmbPacking: row.vac_unit,
                txtHSN: row.vac_hsncode,
                txtRate: Number(row.dec_purchaserate),
                cmbTaxName: row.vac_taxname,
              },
            },
            () => {
              return;
            }
          );
        }
      });
    }
  };

  openTaxMaster = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={
            <TaxMaster refreshTaxNameList={this.refreshTaxNameList} />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  refreshTaxNameList = (TaxNameList) => {
    this.setState({
      TaxNameList,
    });
  };

  onAddClickItem = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<ItemMaster
            showHeading={true}
            OpenFromPurchaseItem="Yes"
            refreshItemNameList={this.refreshItemNameList}
          />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.props.getItemList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  refreshItemNameList = (ItemNameList) => {
    this.setState({
      ItemNameList,
    });
  };

  onTpTextChange = (NewTP) => {
    let txtRate = 0;
    if (Number(NewTP) > 0) {
      // console.log("NewTP", NewTP);
      let numTax = getTaxNumFromStr(this.state.formData.cmbTaxName);
      // console.log("numTax", numTax);
      txtRate = setTaxPaidRate(
        numTax,
        NewTP,
        Number(this.state.formData.txtQty)
      );
      // console.log("txtRate", txtRate);
      this.setState(
        {
          formData: {
            ...this.state.formData,
            txtRate,
          },
        },
        () => {
          this.calBasicAmount();
        }
      );
    } else {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            txtRate,
          },
        },
        () => {
          this.calBasicAmount();
        }
      );
    }
  };
  validateqty = () => {
    if (this.state.formData.txtQty <= 0) {
      this.props.toastErrorMsg("Enter Quantity", "txtQty");
      return false;
    }
    return true;
  };
  openTaxPaidRateARD = () => {
    console.log("openTaxPaidRateARD called");
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Set Rate"
          // labelAgree='Set'
          alertMessage={
            <SetTaxPaidRate
              onTpTextChange={this.onTpTextChange}
              closeTaxPaidRateARD={this.closeTaxPaidRateARD}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  closeTaxPaidRateARD = () => {
    let ARD = null;
    this.setState({ ARD });
  };

  openRichTextBox = (Heading, id, TxtChange) => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Set"
          fullscreenOnly={true}
          alertIcon=""
          alertTitle={Heading}
          alertMessage={
            <MoreInfoTextEditor
              TxtChange={TxtChange}
              Txtid={id}
              updateDetails={this.updateDetails}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  updateDetails = (id, Details) => {
    let txtRemark = this.state.formData.txtRemark,
      withoutText = Details.replace(/<[^>]*>/g, "").trim();

    if (withoutText.length <= 0) {
      Details = withoutText;
    }

    if (id === "Remark") {
      txtRemark = Details;
    }

    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtRemark,
        },
      },
      () => {}
    );
  };

  hasHtmlFormatting = (text) => {
    if (!text) return false;

    const div = document.createElement("div");
    div.innerHTML = text;

    const cleanedText = text.replace(/<p>\s*<\/p>/gi, "");

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = cleanedText;

    const isVisiblyEmpty = tempDiv.textContent.trim() === "";
    const hasTags = /<[^>]+>/.test(cleanedText);

    const result = !isVisiblyEmpty && hasTags;

    return result;
  };

  //#endregion

  render() {
    // let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    // let rowsCount = this.state.searchOpen
    //   ? this.state.searchRowsCount
    //   : this.state.rowsCount;

    // let bolnumTax =
    //   getTaxNumFromStr(this.state.formData.cmbTaxName) > 0 ? false : true;
    let bolnumTax = false;

    return (
      <form>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Purchase Item Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxt
              id="bint_srno"
              label="Sr.No"
              // disabled={true}
              value={this.state.formData.bint_srno}
              handleOnChange={this.handleOnChange}
              width={80}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbStoreName"
              label="Store Name*"
              value={this.state.formData.cmbStoreName}
              handleOnChange={this.handleOnChange}
              items={this.state.StoreNameList}
              width={150}
              maxLength={100}
              colID="vac_storename"
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbItemName"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbItemName"
              label="Item Name*"
              value={this.state.formData.cmbItemName}
              handleOnChange={this.handleOnChange}
              items={getRowColData(this.state.ItemNameList, "vac_itemname")}
              width={500}
              maxLength={100}
              colID="vac_itemname"
              bolVisibleOnAddClickIcon={
                this.props.userPrivilege.Item == "A" ? true : false
              }
              onAddClick={this.onAddClickItem}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbPacking"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbPacking"
              label="Packing*"
              items={this.state.ItemNameList}
              value={this.state.formData.cmbPacking}
              // disabled={this.state.disabledProfileData.AccountTypeDS}
              handleOnChange={this.handleOnChange}
              width={170}
              maxLength={100}
              colID="vac_unit"
              dataFilter={[
                {
                  filterColID: "vac_itemname",
                  value: this.state.formData.cmbItemName,
                },
              ]}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtQty"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtQty"
              label="Quantity*"
              value={this.state.formData.txtQty}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              nextCtrlID="txtRate"
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Set TP Rate"
              variant="outlined"
              onClick={() => {
                if (this.validateqty()) {
                  this.openTaxPaidRateARD();
                }
              }}
              disabled={bolnumTax}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtRate"
              label="Rate*"
              value={this.state.formData.txtRate}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              nextCtrlID="txtDis"
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtBasicAmt"
              label="Basic Amt"
              disabled={true}
              value={this.state.formData.txtBasicAmt}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtDis"
              label="Dis. (%)"
              // disabled={true}
              value={this.state.formData.txtDis}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtDisAmt"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtDisAmt"
              label="Dis. Amount"
              value={this.state.formData.txtDisAmt}
              // disabled={true}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              nextCtrlID="cmbTaxName"
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtTaxable"
              label="Taxable Amount"
              disabled={true}
              value={this.state.formData.txtTaxable}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbTaxName"
              label="Tax Name*"
              items={this.state.TaxNameList}
              value={this.state.formData.cmbTaxName}
              // disabled={this.state.disabledProfileData.AccountTypeDS}
              handleOnChange={this.handleOnChange}
              width={170}
              maxLength={100}
              colID="vac_taxname"
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtremark"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtCGST"
              label="CGST"
              disabled={true}
              value={this.state.formData.txtCGST}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtSGST"
              label="SGST"
              disabled={true}
              value={this.state.formData.txtSGST}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtIGST"
              label="IGST"
              disabled={true}
              value={this.state.formData.txtIGST}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtTotalAmt"
              label="Total Amount"
              disabled={true}
              value={this.state.formData.txtTotalAmt}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
            />
          </Grid>
          {/* <Grid item>
            <CtMultiLineText
              id="txtremark"
              label="Remark"
              value={this.state.formData.txtRemark}
              handleOnChange={this.handleOnChange}
              width={340}
              maxLength={500}
              defaultAction={this.savePurchaseItem}
              validateInput={this.validatePurchaseItem}
            />
          </Grid> */}
          <Grid item lg={12} md={12} sm={12} xs={12}>
            {/*       <p
              style={{
                color: "#666666",
                margin: "0",
                padding: "0",
                fontSize: "14px",
              }}
            >
              Remark
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "0",
              }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: this.state.formData.txtRemark,
                }}
                style={{ margin: "0", padding: "0" }}
              />
              <div style={{ margin: "0", padding: "0" }}>
                <Edit
                  className={"child-button"}
                  style={{
                    border: "none",
                    cursor: "pointer",
                    // color: "#4687FF",
                  }}
                  onClick={() => {
                    this.openRichTextBox(
                      "Remark",
                      "Remark",
                      this.state.formData.txtRemark
                    );
                  }}
                />
              </div>
            </div>
          </Grid> */}

            {!this.hasHtmlFormatting(this.state.formData.txtRemark) ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                }}
              >
                <div style={{ flex: 1 }}>
                  <CtMultiLineText
                    id="txtRemark"
                    label="Remark"
                    value={this.state.formData.txtRemark}
                    handleOnChange={this.handleOnChange}
                    width="100%"
                    maxLength={1000}
                    // onKeyDown={this.props.onKeyDown}
                  />
                </div>
                <Edit
                  className="child-button"
                  style={{
                    marginTop: "26px", // aligns with the input field
                    border: "none",
                    background: "none",
                    cursor: "pointer",
                    color: "#1976d2",
                  }}
                  onClick={() => {
                    this.openRichTextBox(
                      "Remark",
                      "Remark",
                      this.state.formData.txtRemark
                    );
                  }}
                />
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                }}
              >
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "4px",
                      color: "#666666",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Remark
                  </label>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.formData.txtRemark,
                    }}
                    style={{
                      minHeight: "100px",
                      padding: "8px 12px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      background: "#f9f9f9",
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      lineHeight: "1.5",
                      fontFamily:
                        "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    }}
                  />
                </div>
                <Edit
                  className="child-button"
                  style={{
                    marginTop: "26px", // aligns with the top of remark box
                    border: "none",
                    background: "none",
                    cursor: "pointer",
                    color: "#1976d2",
                  }}
                  onClick={() => {
                    this.openRichTextBox(
                      "Remark",
                      "Remark",
                      this.state.formData.txtRemark
                    );
                  }}
                />
              </div>
            )}
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid
            item
            display={
              this.props.userPrivilege.Purchase == "R" ? "none" : "block"
            }
          >
            <CtBtn
              label="Add"
              onClick={this.savePurchaseItem}
              iconName={"save"}
            />
          </Grid>
          <Grid item>
            <CtBtn label="New" onClick={this.clearInfo} variant="outlined" />
          </Grid>
          <Grid
            item
            display={
              this.props.userPrivilege.Purchase !== "M" ? "none" : "block"
            }
          >
            <CtBtn
              label="Remove"
              onClick={this.onDeleteBtnClick}
              iconName={"delete"}
              disabled={this.state.formData.txtSrNo > 0 ? false : true}
            />
          </Grid>
        </Grid>
        <br />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HoCtToastContainer(PurchaseItemEntry));
